import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useContext } from 'react';
import AuthContext from '../contexts/AuthContext';

const AuthGuard = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Safely get auth context without throwing error
  const authContext = useContext(AuthContext);
  const user = authContext?.user;
  const loading = authContext?.loading ?? true;

  useEffect(() => {
    // If no auth context or no user, redirect to login
    if (!authContext || (!loading && !user)) {
      if (location?.pathname !== '/authentication-and-role-assignment') {
        navigate('/authentication-and-role-assignment');
      }
    }
  }, [authContext, user, loading, location, navigate]);

  // Show loading state while checking auth
  if (!authContext || loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-500 mx-auto"></div>
          <p className="mt-4 text-gray-400">جاري التحميل...</p>
        </div>
      </div>
    );
  }

  return children;
};

export default AuthGuard;